import { useContext, useState } from "react";
import styles from "./styles.module.scss";
// import Pagination from "src/components/Pagination";
import { useQuery } from "@apollo/client";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Tab from "src/components/Tab";
import { AppContext, ValueProps } from "src/context";
import { DescribeAseobiFeePercentage } from "src/graphql/queries";
import DashboardLayout from "src/layouts/dashboard";
import useAppStore from "src/store/utils";
import {
  describeAseobiFeePercentage,
  describeAseobiFeePercentageVariables,
} from "src/utils/gql_types";
import { AsoEbiTabType } from "src/utils/types";
import Categories from "./categories";
import Orders from "./orders";

const tabItems: AsoEbiTabType[] = ["groups", "orders"];

function AsoEbi() {
  const [tabState, setTabState] = useState<AsoEbiTabType>("groups");

  const { event } = useAppStore((state) => state);
  const navigate = useNavigate();

  const handleTab = (element: AsoEbiTabType) => {
    setTabState(element);
  };

  const contextValue = useContext<ValueProps | null>(AppContext);
  const setAsoebiFeePercentage = contextValue?.setAsoebiFeePercentage;

  const tab: Record<AsoEbiTabType, JSX.Element> = {
    groups: <Categories />,
    orders: <Orders />,
  };

  useQuery<describeAseobiFeePercentage, describeAseobiFeePercentageVariables>(
    DescribeAseobiFeePercentage,
    {
      variables: {
        eventID: event?.uuid,
      },
      onCompleted(data) {
        setAsoebiFeePercentage &&
          setAsoebiFeePercentage(data.describeAseobiFeePercentage);
      },
      onError(error) {
        if (error?.message !== "unauthenticated") {
          toast.error(
            <p className="toast">
              {error?.message ?? "An error occurred uploading attire image"}
            </p>
          );
        } else {
          navigate("/clear");
        }
      },
    }
  );

  return (
    <DashboardLayout pageName="Aso Ebi">
      <div className={styles["MyParts"]}>
        <div className={styles["guests"]}>
          <div className={styles["guests__tabs"]}>
            <Tab
              tabItems={tabItems}
              tabState={tabState}
              handleTab={handleTab}
            />
          </div>
          <div className={styles["guests__main"]}>{tab[tabState]}</div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AsoEbi;
